import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../utils/analytics';

/**
 * Sends a qr_scan event once when the page is loaded. Use when the only way to reach
 * this page is via a QR (e.g. product detail). qrId identifies which QR/product was scanned.
 */
export function useTrackQrScan(qrId) {
  const { pathname } = useLocation();
  const hasTracked = useRef(false);

  useEffect(() => {
    if (hasTracked.current || qrId == null || qrId === '') return;
    hasTracked.current = true;
    trackEvent('qr_scan', { qr_id: String(qrId), destination: pathname });
  }, [qrId, pathname]);
}
